<template>
  <div class="workTeam-form">
    <!-- 找施工队发布 -->
    <el-form
      ref="workTeamRuleForm"
      :model="workTeamRuleForm"
      :rules="rules"
      label-width="136px"
      class="demo-workTeamRuleForm"
    >
      <el-form-item label="项目名称：" prop="reqName">
        <el-input
          v-model="workTeamRuleForm.reqName"
          placeholder="请输入名称(1~30字符)"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目所在地：" prop="reqAddr">
        <el-cascader
          v-model="workTeamRuleForm.reqAddr"
          :options="areaData"
          size="large"
          placeholder="请选择省/市/区"
          style="width: 100%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="address">
        <el-input v-model="workTeamRuleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="施工总面积：" prop="floorSpace">
        <div class="lflex total-budget">
          <el-input
            v-model="workTeamRuleForm.floorSpace"
            placeholder="请输入数字"
          >
          </el-input>
          <span class="unit">㎡</span>
        </div>
      </el-form-item>
      <el-form-item label="交付时间：" prop="reqEndtime">
        <el-date-picker
          v-model="workTeamRuleForm.reqEndtime"
          type="date"
          placeholder="请选择日期(例如:2021-08-12)"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="施工要求：" prop="constructionRequirements">
        <el-input
          v-model="workTeamRuleForm.constructionRequirements"
          type="textarea"
          placeholder="请输入描述"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人：" prop="linkmanName">
        <el-input
          v-model="workTeamRuleForm.linkmanName"
          placeholder="请输入联系人(1~10字符)"
          maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号：" prop="linkmanMobile">
        <el-input
          v-model="workTeamRuleForm.linkmanMobile"
          placeholder="请输入联系手机号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="sub-btn save-btn" @click="submitForm('save')">
          保存草稿
        </el-button>
        <el-button class="sub-btn" type="primary" @click="submitForm('submit')">
          提交
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 需求显示确认弹框弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      class="demandPopup"
      :close-on-click-modal="false"
    >
      <p class="tCenter">
        提交成功
      </p>
      <div class="one font18 fontW">
        您的需求已提交成功，平台会在1-3个工作日后审核
      </div>

      <div class="btn_group tCenter">
        <el-button class="btn_sure" @click="toDemandHall">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    // 验证手机号
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (regMobile.test(value)) {
        // 合法手机
        return cb()
      }
      cb(new Error('请输入正确的手机号'))
    }
    // 项目总面积, 验证用户输入是否为数字
    var totalBudget = (rule, value, cb) => {
      const reg = new RegExp('^[1-9]*[1-9][0-9]*$')
      if (reg.test(value) && value < 99999999) {
        return cb()
      }
      cb(new Error('请输入正整数'))
    }
    return {
      isEdit: false,
      options: [],
      workTeamRuleForm: {
        reqName: '', // 项目名称
        reqAddr: '', // 项目所在地
        address: '', // 详细地址
        floorSpace: '', // 建筑总面积
        reqEndtime: '', // 交付时间
        constructionRequirements: '', // 施工要求
        linkmanName: '', // 联系人
        linkmanMobile: '' // 联系人手机号
      },
      dialogImageUrl: '',
      dialogVisible: false,
      dialogVisible2: false,
      rules: {
        reqName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 30, message: '1~30个字符', trigger: 'blur' }
        ],
        reqAddr: [
          { required: true, message: '请选择省/市/区', trigger: 'change' }
        ],
        reqEndtime: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        constructionRequirements: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        floorSpace: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          {
            validator: totalBudget,
            message: '请输入数字',
            trigger: 'blur'
          }
        ],
        linkmanName: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 1, max: 10, message: '1~10个字符', trigger: 'blur' }
        ],
        linkmanMobile: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      // 日期选择范围在一个月内
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    }),
    areaData() {
      return this.$store.getters.areaData
    }
  },
  created() {
    let demandId = this.$route.query.id
    if (demandId && demandId !== '') {
      this.queryDetail(demandId)
    }
  },
  methods: {
    // 查询需求详情
    queryDetail(id) {
      this.$http
        .post(`/cms/reqConstructionTeam/findReqVoById/${id}`, { viewindex: 0 })
        .then(res => {
          if (res.data.code === '000000') {
            this.isEdit = true
            let result = res.data.result
            result.reqAddr = [result.province, result.city, result.district]
            this.workTeamRuleForm = result
          }
        })
    },

    submitForm(type) {
      this.$refs['workTeamRuleForm'].validate(valid => {
        if (valid) {
          let formObj = Object.assign({}, this.workTeamRuleForm)

          formObj.province = this.workTeamRuleForm.reqAddr[0]
          formObj.city = this.workTeamRuleForm.reqAddr[1]
          formObj.district = this.workTeamRuleForm.reqAddr[2]
          delete formObj.reqAddr

          // 保存
          type === 'save' ? (formObj.reqStatus = 0) : (formObj.reqStatus = 2)

          let reqUrl = ''
          if (this.isEdit) {
            formObj.reqEndtime =
              formObj.reqEndtime.length > 12
                ? formObj.reqEndtime
                : `${formObj.reqEndtime} 00:00:00`

            reqUrl = '/cms/reqConstructionTeam/updateReqConstructionTeam'
          } else {
            formObj.addUserGuid = this.userInfo.customerId
            reqUrl = '/cms/reqConstructionTeam/saveReqConstructionTeam'
          }

          this.$http.post(reqUrl, formObj).then(res => {
            if (res.data.code === '000000') {
              this.resetData()
              this.$refs.workTeamRuleForm.resetFields()

              // 点击保存
              if (type === 'save') {
                this.$message({
                  type: 'success',
                  message: '保存成功',
                  onClose: () => {
                    if (this.isEdit) {
                      this.$router.push({
                        path: '/user/mineDemand'
                      })
                    }
                  }
                })
              } else {
                // 点击提交
                this.dialogVisible2 = true
              }
            }
          })
        } else {
          return false
        }
      })
    },

    resetData() {
      this.workTeamRuleForm = {
        reqName: '', // 项目名称
        reqAddr: '', // 项目所在地
        address: '', // 详细地址
        floorSpace: '', // 建筑总面积
        reqEndtime: '', // 交付时间
        constructionRequirements: '', // 施工要求
        linkmanName: '', // 联系人
        linkmanMobile: '' // 联系人手机号
      }
    },

    toDemandHall() {
      this.dialogVisible2 = false
      if (this.isEdit) {
        this.$router.push({
          path: '/user/mineDemand'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.workTeam-form {
  .lflex {
    position: relative;
    .unit {
      position: absolute;
      right: -20px;
    }
  }
  .upload-tips {
    font-size: 12px;
    color: #d01c26;
    line-height: 17px;
    margin-top: 6px;
  }
  .sub-btn {
    width: 150px;
    height: 36px;
    border-color: #ce2939;
    background: #ce2939;
    color: #ffffff;
  }
  .save-btn {
    background: #ffffff;
    color: #ce2939;
    margin-right: 30px;
    margin-left: 50px;
  }
}
</style>
